// mock api
import "./_apis_";

// i18n
import "./locales/i18n";

// highlight
import "./utils/highlight";

// scroll bar
import "simplebar/src/simplebar.css";

// map
import "mapbox-gl/dist/mapbox-gl.css";

// lightbox
import "react-image-lightbox/style.css";

// editor
import "react-quill/dist/quill.snow.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-rangeslider/lib/index.css";
// lazy image
import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import { store, persistor } from "./redux/store";
import { SettingsProvider } from "./contexts/SettingsContext";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
import LoadingScreen from "./components/LoadingScreen";
import { AuthProvider } from "./contexts/JWTContext";
import App from "./App";
import * as Sentry from '@sentry/react';

const isProduction = process.env.NODE_ENV === 'production';

// CHECKK BEFORE LIVE
Sentry.init({
  dsn: "https://eb37496036aa848df40ba7c1d19c62d4@o4510979895263232.ingest.us.sentry.io/4510979896508416",
  environment: process.env.NODE_ENV,
  enabled: isProduction,
  integrations: isProduction
    ? [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: true,
          maskAllInputs: false,
          networkDetailAllowUrls: ['https://partnersapi.travomint.co/'],
          networkRequestHeaders: ['X-Custom-Header'],
          networkResponseHeaders: ['X-Custom-Header'],
        }),
      ]
    : [],
  // Session Replay
  replaysSessionSampleRate: 0.05, // 5% sessions
  replaysOnErrorSampleRate: 1.0,  // 100% on error
});



ReactDOM.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SettingsProvider>
            <CollapseDrawerProvider>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </CollapseDrawerProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>,
  document.getElementById("root")
);


